<template>
  <el-container>
    <el-main>
      <el-carousel :interval="4000" arrow="always" height="550px" class="carousel">
        <el-carousel-item>
          <a href="https://jl.t-tool.cn" target="_blank">
            <img class="carousel-image" src="@/assets/images/jianli_jijiane_cn.jpg">
          </a>
        </el-carousel-item>
        <el-carousel-item>
          <a href="https://to.t-tool.cn" target="_blank">
            <img class="carousel-image" src="@/assets/images/www_jijiane_cn.jpg">
          </a>
        </el-carousel-item>
        <el-carousel-item>
          <a href="https://yx.t-tool.cn" target="_blank">
            <img class="carousel-image" src="@/assets/images/yx_wunuli_top.jpg">
          </a>
        </el-carousel-item>
        <el-carousel-item>
          <a href="http://xs.t-tool.cn" target="_blank">
            <img class="carousel-image" src="@/assets/images/book_wunuli_top.jpg">
          </a>
        </el-carousel-item>
        <el-carousel-item>
          <a href="https://gw.zhekouchecang.com" target="_blank">
            <img class="carousel-image" src="@/assets/images/gw_zhekouchecang_com.jpg">
          </a>
        </el-carousel-item>
        <!--
        <el-carousel-item>
          <a href="https://dxerp.zhekouchecang.com" target="_blank">
            <img class="carousel-image" src="@/assets/images/dxerp_zhekouchecang_com.png">
          </a>
        </el-carousel-item>
        <el-carousel-item>
          <a href="https://qt.wunuli.top" target="_blank">
            <img class="carousel-image" src="@/assets/images/qt_wunuli_top.jpg">
          </a>
        </el-carousel-item>-->
      </el-carousel>
      <!--<el-menu
          background-color="transparent"
          text-color="white"
          active-text-color="#409EFF"
          :default-active="showDocTypeNodeToken" class="scrollable-menu" mode="horizontal" @select="handleSelect">
        <el-menu-item
            v-for="item in docTypes"
            :index="item.nodeToken"
            :key="item.nodeToken">
          <h4>{{item.title}}</h4>
        </el-menu-item>
      </el-menu>-->


      <br>
      <el-tabs  stretch @tab-click="handleClick(showDocTypeNodeToken)" v-model="showDocTypeNodeToken"
      >
        <el-tab-pane
            v-for="item in docTypes"
            :index="item.nodeToken"
            :name="item.nodeToken"
            :label="item.title"
            :key="item.nodeToken">
        </el-tab-pane>
      </el-tabs>
      <div style="display: flex; justify-content: center;">
        <masonry-wall
            :items="docList"
            v-if="docList.length >0"
            :key="wallKey"
            class="masonry-container"
        >
          <template v-slot:default="{ item }">
            <el-card
                class="jje-card"
                :body-style="{ padding: '0px' }"
                @click.native="handleClickCard(item)"
            >
              <img v-if="item.imgUrl != null && item.imgUrl != ''" :src="item.imgUrl" alt="Card Image" style="width: 100%; height: auto;"    @error="handleImageError($event, item)"/>
              <div style="text-align: left; padding: 14px;">
                <h2>{{ item.title }}</h2>
                <div style="color: #888888;">
                  <span v-if="showContent" >
                    <span  v-if="item.content != null && item.content != ''">
                      <span v-if="item.imgUrl != null && item.imgUrl != ''">
                         {{ item.content.substring(0, 40)+'...' }}
                      </span>
                      <span v-else>{{ item.content}}</span>
                    </span>
                    <span v-else>{{ item.title }}...</span>
                  </span>
                  <span v-else >{{ item.title }}...</span>
                </div>
                <div style="justify-content: space-between; color: #409EFF; display: flex; margin-top: 10px;">
                  <span>{{ item.updateTime }}</span>
                  <span v-if="showReadCount"> <i class="el-icon-view"></i>&nbsp;{{ item.readCount == null? 0:item.readCount }}次阅读</span>
                  <span v-else><i class="el-icon-s-custom"></i> {{author}}</span>
                </div>
              </div>
            </el-card>
          </template>
        </masonry-wall>
      </div>
    </el-main>
  </el-container>
</template>
<script>

import {author, aId, aSecret, spaceId,showReadCount,showContent} from '@/config/webConfig'
import {
  formatDate,
  saveLocalWithTimestamp,
  getLocalDataWithCheckTimestamp
} from '@/utils/utils';
import masonryWall from 'vue-masonry-wall';
export default {
  name: 'HomePage',
  components: { masonryWall },
  data() {
    return {
      author,
      aId,
      aSecret,
      spaceId,
      showReadCount,
      showContent,
      SHOW_DOC_TYPE:'SHOW_DOC_TYPE',
      docTypes: [],//按钮组
      docList:[],
      currentToken: null, // 跟踪当前正在处理的token
      wallKey:0,
      showDocTypeNodeToken:getLocalDataWithCheckTimestamp(this.SHOW_DOC_TYPE,30) || null,
      token: null,//授权
    }
  },
  watch: {
  },
  methods: {
    //加载数据
    loadData() {
      this.loadDocTypes()//加载文件文档类型\
    },
    //加载标签
    async loadDocTypes() {
      const key = 'DOC_TYPES_'+this.spaceId;   // 更新83的时候加上这个 这样获取不到这个也会重新获取 然后获取儿子也会重新获取
      this.docTypes = []
      let localDocTypes =  getLocalDataWithCheckTimestamp(key,30); //尝试获取本地缓存 30天内有效 文章类型保存30天
      if (localDocTypes == null || localDocTypes.length == 0) {//没有缓存文档类型
        localDocTypes = []
        await this.getToken()//获取token 这时候this.token会有值
        const response = await this.$http.get(
            `/open-apis/wiki/v2/spaces/${this.spaceId}/nodes`,
            {
              headers: {
                'Authorization': this.token,
              }
            }
        );
        if (response.data.code == 0) {//说明获取到文档类型
          const items = response.data.data.items//获取到docTypes
          items.forEach(item => {
            if (item.obj_type == 'docx') {
              let tag = {
                nodeToken: item.node_token,
                title: item.title,
              }
              localDocTypes.push(tag)
            }
            saveLocalWithTimestamp(key, localDocTypes)//把docTypes保存起来
          })
        }
      }
      this.docTypes = localDocTypes
      //获取当前本地选择的 docType
      this.showDocTypeNodeToken = null
      let  localShowDocTypeNodeToken = getLocalDataWithCheckTimestamp(this.SHOW_DOC_TYPE,30); //尝试获取本地缓存 30天内有效
      if (localShowDocTypeNodeToken == null) {//没有当前选择的缓存缓存
        localShowDocTypeNodeToken = this.docTypes[0].nodeToken //默认第一个
        saveLocalWithTimestamp(this.SHOW_DOC_TYPE, localShowDocTypeNodeToken)//把docTypes保存起来
      }
      this.showDocTypeNodeToken = localShowDocTypeNodeToken

      //加载docList
      this.loadDocList(localShowDocTypeNodeToken)

    },
    async loadDocList(showDocTypeNodeToken) {
      // 更新currentToken以跟踪最新的请求
      this.currentToken = showDocTypeNodeToken;
      this.docList = [];
      let localDocList = getLocalDataWithCheckTimestamp("DOC_TYPE_" + showDocTypeNodeToken, 1);//单独类型的文档集合保存1天
      if (localDocList == null) {
        await this.getToken();
        localDocList = [];
        const res = await this.$http.get(
            `/open-apis/wiki/v2/spaces/${spaceId}/nodes`,
            {
              params: { 'parent_node_token': showDocTypeNodeToken },
              headers: { 'Authorization': this.token }
            }
        );

        if (res.data.code === 0) {
          const items = res.data.data.items;
          for (let item of items) {
            if (item.obj_type === 'docx') {
              //保存一份objToken的信息
              localDocList.push({
                title: item.title,
                updateTime: formatDate(item.obj_create_time),//这里使用创建时间作为更新时间
                nodeToken: item.node_token,
                objToken: item.obj_token,
                imgUrl: '', // 先初始化为空字符串
                content: '', // 先初始化为空字符串
                readCount:'',
                imgToken:''
              });
            }
          }
          saveLocalWithTimestamp("DOC_TYPE_" + showDocTypeNodeToken, localDocList);
        }
      }
      // 立即更新 docList 并触发初次渲染
      this.docList = localDocList;
      this.wallKey++;
      // 异步加载图片和描述，避免阻塞主线程
      const maxRequestsPerSecond = 5;
      const requestInterval = 1000 / maxRequestsPerSecond; // 每个请求之间的最小间隔时间

      // 使用 async/await 和 setTimeout 来控制速率

      //这里只拿前面30个的图片和阅读量  30以后的阅读量就从1-300随机一个       // < 30? localDocList.length : 30 //如果长度大于小于99就用这个 如果大于99就99  只加载99个文章
      let endIndex = localDocList.length;
      for (let i = 0; i < endIndex; i++) {
        if (i <= 30){
          await this.loadDocDetails(localDocList[i]);
          if (i < endIndex - 1) {
            await new Promise(resolve => setTimeout(resolve, requestInterval));
          }
        }else {//30后面的
          let doc = localDocList[i]
          let readCount = getLocalDataWithCheckTimestamp("READ_COUNT_" + doc.nodeToken, 15);//阅读量保存半天
          if (readCount == null) {
            //直接
            let randomReadCount = Math.floor(Math.random() * 291) + 10; // 生成10到300之间的随机数
            readCount = randomReadCount
            saveLocalWithTimestamp("READ_COUNT_" + doc.nodeToken, readCount);
          }
        }
      }
      this.wallKey++;

      //批量加载图片
      await this.batchLoadImgUrl()
      // 只有在当前处理的token与最新的token一致时才保存数据
      if (this.currentToken === showDocTypeNodeToken) {
        saveLocalWithTimestamp("DOC_TYPE_" + showDocTypeNodeToken, this.docList);
      }
    },

    async batchLoadImgUrl(){
      let imgTokens = []
      this.docList.forEach(doc => {
        if (doc.imgToken != null && doc.imgToken != ''){
          let imgUrl =  getLocalDataWithCheckTimestamp("IMG_URL_"+doc.imgToken,2) //根据imgToken去获取他的url
          //如果没有
          if(imgUrl == null){
            doc.imgUrl = ''
            imgTokens.push(doc.imgToken)
          }else {
            doc.imgUrl = imgUrl
          }
        }
      })//收集所有的imgToken
      // this.wallKey++;

      const requests = [];
      // 将imgTokens分割成每组batchSize个token的小数组
      await  this.getToken();
      for (let i = 0; i < imgTokens.length; i +=  5) {
        const batch = imgTokens.slice(i, i + 5);
        // 构建每个批次的查询字符串
        let paramsString = batch.map(token => `file_tokens=${encodeURIComponent(token)}`).join('&');
        // 对每个批次发起请求，并保存Promise
        requests.push(this.$http.get(
            `/open-apis/drive/v1/medias/batch_get_tmp_download_url?${paramsString}`,
            {
              headers: { 'Authorization': this.token }
            }
        ));
      }
      // 等待所有请求完成，并收集结果
      try {
        const responses = await Promise.all(requests);
        let allImgUrlsMap = new Map();
        responses.forEach(response => {
          if (response.data.code == 0){
            //将
            let imgUrls = response.data.data.tmp_download_urls
            imgUrls.forEach(imgUrlRes => {
              allImgUrlsMap.set(imgUrlRes.file_token, imgUrlRes.tmp_download_url);
              //这里应该存文件token
              saveLocalWithTimestamp("IMG_URL_"+imgUrlRes.file_token,imgUrlRes.tmp_download_url)
            })
          }
        });//保存所有的图片token的url
        this.docList.forEach(doc => {
          if (doc.imgToken != null && doc.imgToken != ''){
            let imgUrl = allImgUrlsMap.get(doc.imgToken);
            if (imgUrl != null){
              doc.imgUrl = imgUrl
            }
          }
        })
        //这里加载好了 IMG TOKEN   加载了描述和阅读 批量加载图片
        //this.wallKey++;
      } catch (error) {
        console.error('加载图片出错:', error);
      }
    },

    async loadDocDetails(doc) {
      if (doc.imgToken == null || doc.imgToken == ''){
        //加载图片token
        let imgToken = getLocalDataWithCheckTimestamp("IMG_TOKEN_" + doc.nodeToken, 30); //图片token保存30天
        //获取token
        if (imgToken == null){
          imgToken = ''
          await this.getToken();
          const imgTokenRes = await this.$http.get(
              `/open-apis/docx/v1/documents/${doc.objToken}`,
              { headers: { 'Authorization': this.token } }
          );
          if (imgTokenRes.data.code === 0 && imgTokenRes.data.data.document.cover) {
            imgToken = imgTokenRes.data.data.document.cover.token;
          }
        }
        saveLocalWithTimestamp("IMG_TOKEN_" + doc.nodeToken, imgToken);
        doc.imgToken = imgToken
      }
      if (showContent){
        //描述的获取
        if (doc.content == null || doc.content == ''){
          // 加载描述
          let content = getLocalDataWithCheckTimestamp("CONTENT_" + doc.nodeToken, 30);//描述保存30天
          if (content == null) {
            content = doc.title+'...'
            await this.getToken();
            const contentRes = await this.$http.get(
                `/open-apis/docx/v1/documents/${doc.objToken}/raw_content`,
                { headers: { 'Authorization': this.token } }
            );
            if (contentRes.data.code === 0) {
              content = contentRes.data.data.content.substring(0, 140)+'...';
            }
            //如果
          }
          saveLocalWithTimestamp("CONTENT_" + doc.nodeToken, content);
          doc.content = content;
        }
      }
      if (showReadCount){//如果要求展示阅读量
        //阅读量的获取
        //加载阅读量
        // 加载描述
        let readCount = getLocalDataWithCheckTimestamp("READ_COUNT_" + doc.nodeToken, 15);//阅读量保存半天
        if (readCount == null) {
          await this.getToken();
          readCount = ''
          const resStatistics = await this.$http.get(
              `/open-apis/drive/v1/files/${doc.objToken}/statistics`,
              {
                params: {
                  'file_type': 'docx'
                },
                headers: {
                  'Authorization': this.token,
                }
              }
          );
          if (resStatistics.data.code === 0) {
            readCount = resStatistics.data.data.statistics.pv
            readCount = '1'+readCount
            // likeCount = resStatistics.data.data.statistics.like_count  这是点赞
          }
          saveLocalWithTimestamp("READ_COUNT_" + doc.nodeToken, readCount);
        }
        doc.readCount =readCount;
      }
      //保存nodeToken和文章信息 用于doc页面
      saveLocalWithTimestamp("NODE_TOKEN_" + doc.nodeToken, {
        title: doc.title,
        objToken: doc.objToken,
        nodeToken: doc.nodeToken,
        updateTime: doc.updateTime,
        readCount: doc.readCount,
        imgToken:doc.imgToken,
        imgUrl:doc.imgUrl
      });
    },

    handleSelect(nodeToken){
      saveLocalWithTimestamp(this.SHOW_DOC_TYPE,nodeToken)//保存当前展示的type
      this.showDocTypeNodeToken = nodeToken
      this.loadDocList(nodeToken)
    },

    handleClick(nodeToken) {
      saveLocalWithTimestamp(this.SHOW_DOC_TYPE,nodeToken)//保存当前展示的type
      this.loadDocList(nodeToken)
    },

    //获取token
    async getToken() {
      //'https://open.feishu.cn/open-apis/auth/v3/tenant_access_token/internal',
      this.token = null
      const key = 'TOKEN'
      this.token = getLocalDataWithCheckTimestamp(key,0.01)
      if (this.token == null) {
        const tokenRes = await this.$http.post(
            '/open-apis/auth/v3/tenant_access_token/internal',
            {
              app_id: this.aId,
              app_secret: this.aSecret
            },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
        );
        console.log("获取Token:",tokenRes.data)
        // 解析拿到 token
        this.token = 'Bearer ' + tokenRes.data.tenant_access_token
        saveLocalWithTimestamp(key, this.token)
      }
      return  this.token
    },
    handleClickCard(doc) {//点击文档
      this.$router.push({name: 'DocPage', params: {objToken: doc.nodeToken}});
    },
    handleImageError(event,item) {
      //根据这个key去删除
      localStorage.removeItem("IMG_URL_" + item.imgToken);
      event.target.remove();
    }
  },
  mounted() {
    this.loadData();//得到tree 先渲染
  }
}
</script>
<style scoped>
/* 设置整个 el-tabs 容器的高度 */


/* 使用深度选择器穿透到子组件，并增加选择器的优先级 */
::v-deep .el-tabs__nav .el-tabs__item.is-active {
  color: #409EFF !important; /* 强制设置选中标签的文字颜色为蓝色 */
}

/* 使用深度选择器以确保样式应用于内部元素 */
::v-deep  .el-tabs__item.is-active {
  color:#409EFF  !important; /* 改为你的颜色代码 */
}

::v-deep .el-tabs__item {
  height: 100%; /* 标签项占满父容器的高度 */
  color: white !important; /* 改为你的颜色代码 */
  font-size:20px !important; /* 设置字体大小 */
}

/*::v-deep .el-tabs__item:hover {
  background-color: rgba(128, 128, 128, 0.7);
}*/

/* 仅对选中的菜单项应用背景颜色 */
/*.el-menu--horizontal .el-menu-item.is-active {
  background-color: #b3d8ff !important; !* 更改为所需的背景颜色 *!
}*/
/* 如果需要，可以为非活动状态下的菜单项设置透明背景 */
.el-menu--horizontal .el-menu-item {
  background-color: white;
}
.el-menu--horizontal .el-menu-item {
  position: relative; /* 确保子元素的定位是相对于此元素 */
}

.el-menu--horizontal .el-menu-item h4 {
  margin: 0;
  position: relative;
}

.masonry-container {
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)) !important;
  gap: 30px; /* 卡片之间的间距 */
  width: 100%;
  max-width: 1000px;
  padding: 0 0;  /* 增加左右内边距，使卡片更居中 */
}
.jje-card{
  width: 100%;
  margin: 10px 0;
}
.jje-card:hover {
  box-shadow: 3px 3px 10px 3px rgb(241, 204, 72); /* 高亮效果 */
  background: white;
}
.carousel {
  width: 100%;
  position: relative; /* 确保子元素可以相对于此元素定位 */
  overflow: hidden; /* 防止内容溢出 */
}
.carousel-image {
  width: 100%; /* 确保图片宽度占满整个轮播图 */
  height: auto; /* 保持图片的宽高比 */
  display: block;
}
/* 使用 ::v-deep 来确保样式应用于子组件 */
.el-carousel ::v-deep .el-carousel__arrow {
  background-color: rgba(128, 128, 128, 0.7); /* 半透明灰色 */
  width: 50px; /* 设置宽度 */
  height: 80px; /* 设置高度 */
  border-radius: 0; /* 将按钮变为方形 */
  font-size: 40px; /* 可选：调整图标大小 */
}
/* 当鼠标悬停在箭头上时改变背景颜色 */
.el-carousel ::v-deep .el-carousel__arrow:hover {
  background-color: rgba(64, 158, 255, 0.8); /* 更深一点的颜色 */
}
/* 调整左侧箭头位置 */
.el-carousel ::v-deep .el-carousel__arrow--left {
  left: 0px; /* 将左侧箭头向左移动 */
  transform: translateY(-50%); /* 确保垂直居中 */
}
/* 调整右侧箭头位置 */
.el-carousel ::v-deep .el-carousel__arrow--right {
  right: 0px; /* 将右侧箭头向右移动 */
  transform: translateY(-50%); /* 确保垂直居中 */
}
/* 对于移动设备的响应式设计 */
@media (max-width: 768px) {
  .scrollable-menu {
    overflow-x: auto; /* 允许超出屏幕宽度的内容横向滚动 */
    -webkit-overflow-scrolling: touch; /* 提升iOS设备上的滚动体验 */
    white-space: nowrap; /* 确保所有菜单项都在同一行 */
  }

  .scrollable-menu .el-menu-item {
    display: inline-block; /* 确保菜单项按行内块级元素显示 */
    white-space: nowrap; /* 防止菜单项内的文本换行 */
    min-width: auto; /* 根据需要调整最小宽度 */
  }

  .scrollable-menu h4 {
    white-space: nowrap; /* 防止标题内的文本换行 */
    overflow: hidden; /* 如果文本超出容器宽度则隐藏 */
    text-overflow: ellipsis; /* 当文本被截断时显示省略号 */
  }

  .carousel {
    height: 190px !important; /* 调整轮播图高度并强制应用 */
  }
  /* 使用 ::v-deep 来确保样式应用于子组件 */
  .el-carousel ::v-deep .el-carousel__arrow {
    /* 更改箭头大小 */
    top: 17%; /* 垂直居中 */
    width: 30px; /* 设置宽度 */
    height: 50px; /* 设置高度 */
    font-size: 30px; /* 可选：调整图标大小 */
  }
  .masonry-container {
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr)) !important;
    --masonry-columns: 1;
    padding: 0 0; /* 增加左右内边距，使卡片更居中 */
  }
  .jje-card {
    margin: 8px 0; /* 手机端只保留上下间距 */
  }
}
</style>
